import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.freeze";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, addObj, putObj, delObj, putAlarmPush } from '@/api/admin/user';
import { deptRoleList, fetchroleList } from '@/api/admin/role';
import { getAllMenu, getRoleMenu, setRoleMenu } from '@/api/admin/role';
import Selecttree from '@/components/treeSelect';
import moment from 'moment';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import { getStore } from '@/util/store';
export default {
  name: 'userManage',
  components: {
    // userForm: () => import('./userForm'),
    stationModal: function stationModal() {
      return import("./stationModal");
    },
    Selecttree: Selecttree
  },
  data: function data() {
    return {
      iphoneval: '',
      proname: '',
      seachform: {},
      test: false,
      param: {
        page: {
          current: 1,
          size: 10
        },
        roleId: '',
        menuIds: []
      },
      columnlist3: [{
        prop: 'account',
        label: this.$t('userManage.userName')
      }, {
        prop: 'phone',
        label: this.$t('userManage.phoneNum')
      } // { prop: 'realName', label: '公司名称' },
      // { prop: 'roleName', label: '角色名称' }
      ],
      loading: false,
      tableData: [],
      tableAlarmFlag: [],
      columnlist: Object.freeze([{
        prop: 'index',
        label: this.$t('realdetile.serNum'),
        width: 100
      }, {
        prop: 'projectName',
        label: this.$t('manipulation.devName')
      }, {
        prop: 'phone',
        label: this.$t('userManage.account')
      }, {
        prop: 'account',
        label: this.$t('userManage.operatorName')
      }, // { prop: 'company', label: '公司名称' },
      {
        prop: 'roleName',
        label: this.$t('userManage.operaPermission')
      } // { prop: 'depName', label: '管理电站' }
      ]),
      page: {
        current: 1,
        size: 5,
        total: 0,
        pages: 1
      },
      dialogFormVisible: false,
      form: {
        title: '',
        formItem: {
          // userId: '',
          account: '',
          tenantId: this.$store.getters.tenantId,
          deptId: '1315491184663224321',
          password: '',
          phone: '',
          // realName: '',
          roleId: '' // 整数roleId数组

        },
        roleId: '',
        // 显示roleName，实际传roleId的数组（只有一个值）
        options: [],
        rules: Object.freeze({
          account: [{
            required: true,
            message: this.$t('userManage.addAccountName'),
            trigger: 'blur'
          }],
          password: [{
            required: false,
            message: this.$t('userManage.addPassword'),
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: this.$t('userManage.addPhone'),
            trigger: 'blur'
          }, {
            pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
            message: this.$t('userManage.phoneFault')
          }],
          // realName: [{ required: true, message: '请添加公司名称', trigger: 'blur' }],
          roleId: [{
            required: false,
            message: this.$t('userManage.addRole'),
            trigger: 'blur'
          }]
        })
      },
      auth: {
        dialogStationVisible: false,
        menuData: [],
        activeMenuData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      },
      station: {
        title: this.$t('userManage.assignItem'),
        dialogStationVisible: false,
        userId: NaN
      },
      isshow: false,
      prop: {
        value: 'id',
        label: 'title'
      },
      isClearable: true,
      // 可清空（可选）
      isAccordion: true,
      // 可收起（可选）
      rolelist: []
    };
  },
  created: function created() {
    this.getUserData();
    this.getRoleList();
    this.getfetchroleList();
  },
  computed: _objectSpread({}, mapGetters(['permission'])),
  mounted: function mounted() {// console.log(moment("20211226").startOf('day').fromNow())
  },
  methods: {
    search: function search() {
      this.param.page.current = 1;
      this.getUserData();
    },
    refresh: function refresh() {
      this.param.page.current = 1;
      this.proname = "";
      this.iphoneval = "";
      this.getUserData();
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var _this = this;

      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;
      var that = this;
      that.spanArr = [];
      that.pos = 0;
      var data = this.tableData; //遍历数据

      data.forEach(function (item, index) {
        if (index === 0) {
          _this.spanArr.push(1);

          _this.pos = 0;
        } else {
          if (data[index].projectName && data[index].projectName === data[index - 1].projectName) {
            _this.spanArr[_this.pos] += 1;

            _this.spanArr.push(0);
          } else {
            _this.spanArr.push(1);

            _this.pos = index;
          }
        }
      });

      if (columnIndex === 1) {
        var _row = this.spanArr[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      } else {
        return false;
      }
    },
    getfetchroleList: function getfetchroleList() {
      var _this2 = this;

      fetchroleList({
        size: 200
      }).then(function (res) {
        res = res.data.data;
        _this2.rolelist = res.records;
      });
    },
    getValue: function getValue(e) {
      this.form.roleId = e;
      this.changesel(e);
    },
    // 表格详情没有内容隐藏箭头
    getRowClass: function getRowClass(row) {
      if (!row.row.children || !row.row.children.length) {
        // 即该行没有子元素时，添加row-expand-cover类
        return 'row-expand-cover';
      }
    },
    expandHandle: function () {
      var _expandHandle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row, data) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(row, data[0]);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function expandHandle(_x, _x2) {
        return _expandHandle.apply(this, arguments);
      }

      return expandHandle;
    }(),
    // 获取用户数据
    getUserData: function getUserData() {
      var _this3 = this;

      this.loading = true;
      fetchList(_objectSpread(_objectSpread({}, this.param.page), {}, {
        phone: this.iphoneval,
        projectName: this.proname
      })).then(function (res) {
        res = res.data.data;
        res.records.map(function (item, index) {
          item.index = index + 1;
        });
        _this3.tableData = res.records;
        _this3.loading = false;
        var _res = res,
            total = _res.total,
            pages = _res.pages,
            current = _res.current,
            size = _res.size;
        _this3.page = {
          total: total,
          pages: pages,
          current: current,
          size: size
        };
      });
    },
    getRoleList: function getRoleList() {
      var _this4 = this;

      deptRoleList().then(function (res) {
        res = res.data.data;
        _this4.form.options = res;
      });
    },
    changesel: function changesel(val) {
      var res = this.rolelist.filter(function (v) {
        return v.id === val;
      });

      if (res.length > 0 && res[0].isActivate) {
        this.isshow = true;
      } else {
        this.isshow = false;
      }
    },
    // 分页导航
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.page.current = val;
      this.getUserData();
    },
    // 新增用户的表单
    handleAdd: function handleAdd() {
      this.form.roleId = '';
      this.form.title = this.$t('userManage.addUser');
      this.dialogFormVisible = true;
      this.form.formItem = {
        account: '',
        tenantId: this.$store.getters.tenantId,
        deptId: '1315491184663224321',
        password: '',
        phone: '',
        // realName: '',
        roleId: '' // 整数roleId数组

      };
    },
    // handleBtn(index, row) {
    //     const {id,alarmPushFlag } = row;
    //     let obj = { userId:id,alarmPushFlag };
    //     putAlarmPush(obj).then(res => {
    //         if (res.data.code === 200) {
    //             this.$message.success(`修改成功`);
    //             this.form.formItem = {};
    //             // this.getUserData();
    //         } else {
    //             this.$message.error('修改失败，请稍后重试');
    //             this.form.formItem = {};
    //         }
    //     });
    // },
    // 修改用户的表单
    handleEdit: function handleEdit(index, row) {
      this.form.title = this.$t('userManage.chaAccount');
      var account = row.account,
          password = row.password,
          phone = row.phone,
          id = row.id,
          roleId = row.roleId,
          status = row.status,
          isActivate = row.isActivate;

      if (isActivate) {
        this.isshow = true;
      }

      this.form.formItem = {
        account: account,
        phone: phone,
        id: id,
        roleId: roleId,
        password: password,
        status: status,
        isActivate: isActivate,
        deptId: '1315491184663224321'
      };
      this.form.roleId = roleId;
      this.dialogFormVisible = true;
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.form.formItem.roleId = this.form.roleId;

      if (this.form.formItem.password && this.form.formItem.password.length < 6) {
        this.$message.error(this.$t('userManage.passLess'));
        return;
      }

      if (this.form.title === this.$t('userManage.addUser')) {
        this.$refs.ruleForm.validate(function (valid) {
          if (valid && _this5.form.roleId) {
            addObj(_this5.form.formItem).then(function (res) {
              if (res.data.code === 200) {
                _this5.$message.success(_this5.$t('userManage.addSuc'));

                _this5.getUserData();
              } else {
                _this5.$message.error(_this5.$t('userManage.addFauRepeat'));

                return;
              }

              _this5.handleClose();
            });
          } else {
            _this5.$message.warning(_this5.$t('userManage.fillComplete'));

            return;
          }
        });
      } else {
        this.$refs.ruleForm.validate(function (valid) {
          if (valid && _this5.form.roleId) {
            putObj(_this5.form.formItem).then(function (res) {
              if (res.data.code === 200) {
                _this5.$message.success(_this5.$t('userManage.chaSuc'));

                _this5.getUserData();
              } else {
                _this5.$message.error(_this5.$t('userManage.chaFauRepeat'));
              }

              _this5.handleClose();
            });
          } else {
            _this5.$message.warning(_this5.$t('alarmSetting.fillComplete'));

            return;
          }
        });
      }
    },
    handleCancel: function handleCancel(done) {
      this.form.formItem = {};
      this.isshow = false;
      this.form.roleId = '';
      done();
    },
    handleClose: function handleClose() {
      this.form.formItem = {};
      this.isshow = false;
      this.form.roleId = '';
      this.dialogFormVisible = false;
    },
    // 删除用户
    handleDel: function handleDel(index, row) {
      var _this6 = this;

      // 二次确认删除
      this.$confirm(this.$t('alarmSetting.promptContent') + "?", this.$t('alarmSetting.prompt'), {
        type: 'warning'
      }).then(function () {
        delObj({
          ids: row.id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this6.$message.success($t('alarmSetting.deleteSuc'));

            if (index === 0) {
              _this6.param.page.current -= 1;

              _this6.getUserData();
            }

            _this6.tableData.splice(index, 1);

            _this6.page.total -= 1;
          } else {
            _this6.$message.error($t('alarmSetting.deleteFau'));
          }
        });
      }).catch(function () {});
    },
    // 分电站表单
    handleStation: function handleStation(index, row) {
      console.log('row', row);
      this.station.title = this.$t('userManage.assignItem');
      this.$refs.stationModal.getUserStation(row);
      this.station.dialogStationVisible = true;
    },
    handleStationClose: function handleStationClose(num) {
      this.station.dialogStationVisible = false;

      if (num === '0') {
        this.getUserData();
      }
    }
  }
};